module.exports = __webpack_public_path__ + "img/eyyb-t3.3dde3134.jpg";